<template>
  <section v-if="firstArticle" :class="$style.container">
    <Wrapper :class="$style.inner">
      <h2 :class="$style.title">
        {{ $t('AdviceHub.News.title') }}
      </h2>
      <div :class="$style.grid">
        <ArticleThumbnail
          v-if="firstArticle"
          :class="$style.big"
          :article="firstArticle"
          is-big
        />
        <div :class="$style.right">
          <ArticleThumbnail
            v-for="(article, articleIndex) in lastThreeArticles"
            :key="articleIndex"
            :article="article"
            is-small
          />
        </div>
      </div>
    </Wrapper>
  </section>
</template>

<script>
import ArticleThumbnail from '~/components/ArticleThumbnail'
import { getFormatedLink } from '~/mixins/getFormatedLink'

export default {
  name: 'News',

  components: {
    ArticleThumbnail,
  },

  mixins: [getFormatedLink],

  props: {
    slice: {
      type: Object,
      required: true,
    },
  },

  computed: {
    firstArticle() {
      return this.slice.items[0]
    },

    lastThreeArticles() {
      return this.slice.items.slice(1, 4)
    },
  },
}
</script>

<style lang="scss" module>
.container {
  margin: 80px 24px;
}

.title {
  @include typo-extra-title;
  font-weight: 200;
}

.grid {
  max-width: 780px;
  margin: 24px auto 0;

  @include above(large) {
    display: flex;
    gap: 40px;
    max-width: none;
    margin: 0;
    margin-top: 24px;
  }
}

.big {
  flex-basis: 70%;
  @include above(large) {
    max-width: 620px;
  }
}

.right {
  display: none;
  margin-top: 40px;

  @include above(small) {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }
  @include above(large) {
    margin-top: 0;
  }
}
</style>
